const LANGUAGE_LB = { id: "lb", name: "op Lëtzebuergesch" };
const LANGUAGE_DE = { id: "de", name: "auf Deutsch" };
const LANGUAGE_EN = { id: "en", name: "in English" };
const LANGUAGE_FR = { id: "fr", name: "en Français" };
const LANGUAGE_PT = { id: "pt", name: "em Português" };

export default {
    SIMPLE_DATE_API_FORMAT: 'YYYY-MM-DD',
    ISO_DATE_WITH_SECONDS_API_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSZZ",
    SIMPLE_DATE_DISPLAY_FORMAT: {
        de: 'DD.MM.YYYY',
        fr: 'DD/MM/YYYY',
        en: 'DD/MM/YYYY'
    },
    SIMPLE_DATE_WITH_HOUR_DISPLAY_FORMAT: {
        de: 'DD.MM.YYYY HH:mm',
        fr: 'DD/MM/YYYY HH:mm',
        en: 'DD/MM/YYYY HH:mm'
    },

    JOIN_REQUEST_STATUS: {
        REQUESTED: "requested",
        APPROVED: "approved",
        DECLINED: "declined"
    },

    GROUP_REQUEST_STATUS: {
        CREATION_REQUEST: "creation-requested",
        MIGRATION_REQUESTED: "migration-requested",
        APPROVED: "approved",
        DECLINED: "declined"
    },

    POST_STYLES: {
        EVENT: "event",
        PICTURE_GALLERY: "pictureGallery",
        VIDEO: "video",
        DOSSIER: "dossier",
        DATA: "data",
        AUDIO: "audio",
        TICKER: "ticker",
        CAMPAIGN: "campaign",
        POLL: "poll",
        STORY_TELLING: "storyTelling"
    },

    LANGUAGES: [
        LANGUAGE_LB,
        LANGUAGE_DE,
        LANGUAGE_FR,
        LANGUAGE_EN,
        LANGUAGE_PT
    ],
    LANGUAGE_LB: LANGUAGE_LB,
    LANGUAGE_DE: LANGUAGE_DE,
    LANGUAGE_FR: LANGUAGE_FR,
    LANGUAGE_EN: LANGUAGE_EN,
    LANGUAGE_PT: LANGUAGE_PT,


    FILE_SIZE_MAX: 10 * 1024 * 1024,
    PICTURE_SIZE_PRINT_QUALITY: 2500,
    MIN_CROP_WIDTH: 50,

    GROUP_REQUEST_NAME_MAX_LENGTH: 50,
    GROUP_REQUEST_DESCRIPTION_MAX_LENGTH: 1000,
    DECLINE_USER_JOIN_REQUEST_COMMENT_MAX_LENGTH: 150,
    DELETE_USER_FROM_GROUP_COMMENT_MAX_LENGTH: 150
};



// WEBPACK FOOTER //
// ./js/mywort/commons/configurations/Constants.js